/** CasaMapa partner portal nav audiences (aligned with advertise page account types). */
export const CASAMAPA_PARTNER_AUDIENCES = Object.freeze({
  ALL: "all",
  AGENCY: "agency",
  VENDOR: "vendor",
});

export function resolveCasaMapaPartnerAudience(partner) {
  return partner?.partnerType === "vendor"
    ? CASAMAPA_PARTNER_AUDIENCES.VENDOR
    : CASAMAPA_PARTNER_AUDIENCES.AGENCY;
}

export function isCasaMapaVendorPartner(partner) {
  return resolveCasaMapaPartnerAudience(partner) === CASAMAPA_PARTNER_AUDIENCES.VENDOR;
}

export function filterCasaMapaPartnerTabs(tabs, partner) {
  const audience = resolveCasaMapaPartnerAudience(partner);
  return tabs.filter((tab) => {
    if (!tab.audiences?.length) {
      return true;
    }
    return (
      tab.audiences.includes(CASAMAPA_PARTNER_AUDIENCES.ALL) || tab.audiences.includes(audience)
    );
  });
}
